// imports
import { APP_DATA, APP_ID, COUNTRY_DIAL_CODES, FORM_SUBMIT_MESSAGE_TEXT_ID, VALID_EMAIL_REGEX, PASSWORD_PATTERN_REGEX, LOGIN_FORM, SIGN_UP_FORM, SIGN_UP_OTP_FORM, FORM_SUBMIT_BUTTON_ID, FORM_SUBMIT_BUTTON_LOADING_CLASS, LOG_IN_WITH_GOOGLE_BUTTON_ID, LOG_IN_WITH_FACEBOOK_BUTTON_ID, RESEND_OTP_BUTTON_DEFAULT_TEXT, SOCIAL_MEDIA_PLATFORMS, SOCIAL_MEDIA_PLATFORM_SHARE_URL, FORM_CONTROL, ENV_DEV, ENV_BETA, DEV_WIDGET_URL, BETA_WIDGET_URL, PROD_WIDGET_URL, SOCIAL_MEDIA_SHARE_BUTTON_ID, FORGOT_PASSWORD_FORM, RESET_PASSWORD_FORM, FORM_SUBMIT_MESSAGE_CONTAINER_ID, SUCCESS_BACKGROUND_CLASS, DANGER_BACKGROUND_CLASS } from "./constants";
import { getLocationDetails, getPublishSlug } from "./apis";
// import * as CountryFlagsSVG from "country-flag-icons/string/3x2";

export const attachScript = (url, callback) => {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    script.onreadystatechange = callback;
    script.onload = callback;
    document.head.appendChild(script);
};

export const loadScripts = (urls, callback) => {
    let loadedCount = 0;
    let multiCallback = () => {
        loadedCount++;
        if (loadedCount >= urls.length) {
            callback.call(this, arguments);
        }
    };
    for (let url of urls) {
        attachScript(url, multiCallback);
    }
};

export const isEmailValid = email => {
    return VALID_EMAIL_REGEX.test(email);
};

export const isPasswordValid = password => {
    return PASSWORD_PATTERN_REGEX.test(password);
};

export const setFormFieldErrorContainerMaxWidth = () => {
    const formContainer = document.getElementById(`${APP_ID}-login-sign-up-form-container`);
    const appBody = document.getElementById(`${APP_ID}-app-body`);
    let width = 0;

    if (formContainer && formContainer.offsetWidth) {
        width = formContainer.offsetWidth;
    } else if (appBody && appBody.offsetWidth) {
        width = appBody.offsetWidth;
    }

    let elemList = document.getElementsByClassName(`${APP_ID}-form-field-error-container`);

    for (let i = 0; i < elemList.length; i++) {
        elemList[i].style.maxWidth = `${width}px`
    }
};

export const setFormSubmitMessageContainerMaxWidth = () => {
    try {
        const formContainer = document.getElementById(`${APP_ID}-login-sign-up-form-container`);
        const appBody = document.getElementById(`${APP_ID}-app-body`);
        let width = 0;

        if (formContainer && formContainer.offsetWidth) {
            width = formContainer.offsetWidth;
        } else if (appBody && appBody.offsetWidth) {
            width = appBody.offsetWidth;
        }

        let elemList = document.getElementsByClassName(FORM_SUBMIT_MESSAGE_CONTAINER_ID);

        for (let i = 0; i < elemList.length; i++) {
            elemList[i].style.maxWidth = `${width}px`
        }
    } catch (err) {
        console.error(err);
    }
};

export const enableFormSubmitButtonAndShowLoader = (form) => {
    const supportedForms = [LOGIN_FORM, SIGN_UP_FORM, SIGN_UP_OTP_FORM, FORGOT_PASSWORD_FORM, RESET_PASSWORD_FORM];
    if (supportedForms.includes(form)) {
        const button = document.getElementById(FORM_SUBMIT_BUTTON_ID[form].submitButton);
        button.disabled = false;
        button.classList.remove(FORM_SUBMIT_BUTTON_LOADING_CLASS);
    }

    if (form === SIGN_UP_OTP_FORM && document.getElementById(FORM_SUBMIT_BUTTON_ID[form].resendEmailOtp).innerText.toUpperCase() === RESEND_OTP_BUTTON_DEFAULT_TEXT.toUpperCase()) {
        const button = document.getElementById(FORM_SUBMIT_BUTTON_ID[form].resendEmailOtp);
        button.disabled = false;
    }

    const googleLoginButton = document.getElementById(LOG_IN_WITH_GOOGLE_BUTTON_ID);
    const facebookLoginButton = document.getElementById(LOG_IN_WITH_FACEBOOK_BUTTON_ID);

    if (googleLoginButton) {
        googleLoginButton.disabled = false;
    }
    if (facebookLoginButton) {
        facebookLoginButton.disabled = false;
    }
};

export const disableFormSubmitButtonAndShowLoader = (form) => {
    const supportedForms = [LOGIN_FORM, SIGN_UP_FORM, SIGN_UP_OTP_FORM, FORGOT_PASSWORD_FORM, RESET_PASSWORD_FORM];
    if (supportedForms.includes(form)) {
        const button = document.getElementById(FORM_SUBMIT_BUTTON_ID[form].submitButton);
        button.disabled = true;
        button.classList.add(FORM_SUBMIT_BUTTON_LOADING_CLASS);
    }

    if (form === SIGN_UP_OTP_FORM) {
        const button = document.getElementById(FORM_SUBMIT_BUTTON_ID[form].resendEmailOtp);
        button.disabled = true;
    }

    const googleLoginButton = document.getElementById(LOG_IN_WITH_GOOGLE_BUTTON_ID);
    const facebookLoginButton = document.getElementById(LOG_IN_WITH_FACEBOOK_BUTTON_ID);

    if (googleLoginButton) {
        googleLoginButton.disabled = true;
    }
    if (facebookLoginButton) {
        facebookLoginButton.disabled = true;
    }
};

export const disableButtonById = (id) => {
    try {
        const button = document.getElementById(id);

        if (button) {
            button.disabled = true;
        }
    } catch (err) {
        console.error(err);
    }
};

export const showFormSubmitSuccess = (form, successMessage) => {
    const elem = document.getElementById(`${FORM_SUBMIT_MESSAGE_TEXT_ID[form]}`);
    const parent = elem.parentNode;

    if (elem) {
        elem.innerText = successMessage;
    }

    if (parent.classList.contains(FORM_SUBMIT_MESSAGE_CONTAINER_ID)) {
        parent.classList.add(SUCCESS_BACKGROUND_CLASS);
    }
};

export const hideFormSubmitSuccess = (form) => {
    const elem = document.getElementById(`${FORM_SUBMIT_MESSAGE_TEXT_ID[form]}`);
    const parent = elem.parentNode;

    if (elem) {
        elem.innerText = "";
    }

    if (parent.classList.contains(FORM_SUBMIT_MESSAGE_CONTAINER_ID)) {
        parent.classList.remove(SUCCESS_BACKGROUND_CLASS);
    }
};

export const showFormSubmitError = (form, errorMessage) => {
    const elem = document.getElementById(`${FORM_SUBMIT_MESSAGE_TEXT_ID[form]}`);
    const parent = elem.parentNode;

    if (elem) {
        elem.innerText = errorMessage;
    }

    if (parent.classList.contains(FORM_SUBMIT_MESSAGE_CONTAINER_ID)) {
        parent.classList.add(DANGER_BACKGROUND_CLASS);
    }
};

export const hideFormSubmitError = (form) => {
    const elem = document.getElementById(`${FORM_SUBMIT_MESSAGE_TEXT_ID[form]}`);
    const parent = elem.parentNode;

    if (elem) {
        elem.innerText = "";
    }

    if (parent.classList.contains(FORM_SUBMIT_MESSAGE_CONTAINER_ID)) {
        parent.classList.remove(DANGER_BACKGROUND_CLASS);
    }
};

export const setGlobalAppData = () => {
    window[APP_DATA] = {
        env: null,
        name: null,
        url: null,
        email: null,
        signUpId: null,
        userToken: null,
        mobileCountryCode: "US",
        mobileDialCode: "+1",
        activeForm: LOGIN_FORM,
        resendOtpTimerId: null,
        forgotPasswordEmail: null
    }
};

export const resetGlobalAppData = () => {
    window[APP_DATA] = {
        env: null,
        name: null,
        url: null,
        email: null,
        signUpId: null,
        userToken: null,
        mobileCountryCode: "US",
        mobileDialCode: "+1",
        activeForm: LOGIN_FORM,
        resendOtpTimerId: null,
        forgotPasswordEmail: null
    }
};

export const updateGlobalAppData = (data) => {
    Object.entries(data).forEach(prop => window[APP_DATA][prop[0]] = prop[1]);
};

export const setFormHelperMessageContainerMaxWidth = () => {
    const formContainerWidth = document.getElementById(`${APP_ID}-login-sign-up-form-container`).offsetWidth;
    let elemList = document.getElementsByClassName(`${APP_ID}-form-helper-message-container`);

    for (let i = 0; i < elemList.length; i++) {
        elemList[i].style.maxWidth = `${formContainerWidth}px`
    }
};

export const clearResendOtpTimer = () => {
    if (window[APP_DATA].resendOtpTimerId) {
        const resendOtpButton = document.getElementById(FORM_SUBMIT_BUTTON_ID.signUpOtpForm.resendEmailOtp);
        const resendOtpButtonText = document.getElementById(`${APP_ID}-sign-up-otp-form-resend-email-otp-text`);

        clearInterval(window[APP_DATA].resendOtpTimerId);
        resendOtpButton.disabled = false;
        resendOtpButtonText.innerText = "Resend OTP";
    }
}

export const setResetOtpTimer = () => {
    let time = 50;
    let timerId = null;
    const resendOtpButton = document.getElementById(FORM_SUBMIT_BUTTON_ID.signUpOtpForm.resendEmailOtp);
    const resendOtpButtonText = document.getElementById(`${APP_ID}-sign-up-otp-form-resend-email-otp-text`);

    resendOtpButton.disabled = true;
    resendOtpButtonText.innerText = `Resend OTP ${time}`;

    timerId = setInterval(() => {
        if (time === 1) {
            reset();
        } else {
            time = time - 1;
            resendOtpButtonText.innerText = `Resend OTP ${time}`;
        }
    }, 1000);

    window[APP_DATA].resendOtpTimerId = timerId;

    const reset = () => {
        window[APP_DATA].resendOtpTimerId = null;
        clearInterval(timerId);
        time = 50;
        resendOtpButton.disabled = false;
        resendOtpButtonText.innerText = "Resend OTP";
    }
};

// export const selectCountry = (e = null, countryCode = null) => {
//     try {
//         let selectedCountryCode = "";
//         if (e) {
//             selectedCountryCode = e.value;
//         } else if (countryCode) {
//             selectedCountryCode = countryCode;
//         } else {
//             throw "selectCountry(): cannot get selectedCountryCode";
//         }

//         let dropdownElem = document.getElementById(`${APP_ID}-form-control-dial-code-dropdown`);
//         const options = Array.apply(null, dropdownElem.options);
//         let prevCountry = options.find(c => c.value === window[APP_DATA].mobileCountryCode);
//         let nextCountry = options.find(c => c.value === selectedCountryCode);

//         if (countryCode) {
//             for (let opt, j = 0; opt = options[j]; j++) {
//                 if (opt.value === countryCode) {
//                     dropdownElem.selectedIndex = j;
//                     break;
//                 }
//             }
//         }

//         prevCountry.innerHTML = `${COUNTRY_DIAL_CODES[prevCountry.id].name + ' (' + COUNTRY_DIAL_CODES[prevCountry.id].dial_code + ')'}`;

//         const nextCountryObj = COUNTRY_DIAL_CODES.find(c => c.code === selectedCountryCode);
//         nextCountry.innerHTML = `${nextCountryObj.code} (${nextCountryObj.dial_code})`;

//         window[APP_DATA].mobileCountryCode = selectedCountryCode;
//         window[APP_DATA].mobileDialCode = nextCountryObj.dial_code;

//         let elem = document.getElementById(`${APP_ID}-form-control-dial-code-selected-country`);
//         const flagHtml = `<div class="country flag logo">${getCountryFlagSVG(selectedCountryCode)}</div>`;
//         elem.innerHTML = flagHtml;
//     } catch (err) {
//         console.error(err);
//     }
// };

// export const setUserCountryAndDialCode = async () => {
//     if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(async pos => {
//             const locationDetails = await getLocationDetails({ lat: pos.coords.latitude, long: pos.coords.longitude });

//             if (locationDetails && document.getElementById(`${APP_ID}-form-control-dial-code-dropdown`)) {
//                 selectCountry(null, locationDetails["country_code"]);
//             } else if (locationDetails) {
//                 window[APP_DATA].mobileCountryCode = locationDetails["country_code"];
//                 const countryObj = COUNTRY_DIAL_CODES.find(c => c.code === locationDetails["country_code"]);
//                 window[APP_DATA].mobileDialCode = countryObj.dial_code;
//             }
//         }, err => {
//             console.error(err);
//         }, { timeout: 5000 });
//     }
// };

// export const getCountryFlagSVG = (code) => {
//     return CountryFlagsSVG[code];
// };

export const hideSocialLoginForm = () => {
    const formContainer = document.getElementById(`${APP_ID}-social-login-container`);
    formContainer.style.height = 0;
    formContainer.style.overflow = "hidden";
};

export const showSocialLoginForm = () => {
    const formContainer = document.getElementById(`${APP_ID}-social-login-container`);
    formContainer.style.height = "initial";
    formContainer.style.overflow = "initial";
};

export const getPropIfNotNull = (obj, propName) => {
    if (obj) {
        if (obj[propName]) {
            return obj[propName];
        } else {
            return null;
        }
    }

    return null;
};

export const encodeUrl = (url) => {
    return encodeURIComponent(url);
};

export const openPopup = (url, winName = "", w = "550", h = "450", scroll = "yes") => {
    const leftPosition = (screen.width) ? (screen.width - w) / 2 : 0;
    const topPosition = (screen.height) ? (screen.height - h) / 2 : 0;
    const settings = "height=" + h + ",width=" + w + ",top=" + topPosition + ",left=" + leftPosition + ",scrollbars=" + scroll + ",resizable";
    const popupWindow = window.open(url, winName, settings);

    if (window.focus) {
        popupWindow.focus();
    }

    return false;
};

export const handleSocialMediaShare = (platform) => {
    switch (platform) {
        case SOCIAL_MEDIA_PLATFORMS.facebook:
            openPopup(`${SOCIAL_MEDIA_PLATFORM_SHARE_URL.facebook}?u=${encodeUrl(`${window[APP_DATA].shareLink}&utm_medium=${SOCIAL_MEDIA_PLATFORMS.facebook}`)}`);
            break;
        case SOCIAL_MEDIA_PLATFORMS.twitter:
            openPopup(`${SOCIAL_MEDIA_PLATFORM_SHARE_URL.twitter}?url=${encodeUrl(`${window[APP_DATA].shareLink}&utm_medium=${SOCIAL_MEDIA_PLATFORMS.twitter}`)}`);
            break;
        case SOCIAL_MEDIA_PLATFORMS.pinterest:
            openPopup(`${SOCIAL_MEDIA_PLATFORM_SHARE_URL.pinterest}?url=${encodeUrl(`${window[APP_DATA].shareLink}&utm_medium=${SOCIAL_MEDIA_PLATFORMS.pinterest}`)}${window[APP_DATA].cosell.imageUrl ? `&media=${encodeUrl(window[APP_DATA].cosell.imageUrl)}` : ""}`, "", "1000", "600");
            break;
        case SOCIAL_MEDIA_PLATFORMS.whatsapp:
            openPopup(`${SOCIAL_MEDIA_PLATFORM_SHARE_URL.whatsapp}?text=${encodeUrl(`${window[APP_DATA].shareLink}&utm_medium=${SOCIAL_MEDIA_PLATFORMS.whatsapp}`)}`);
    }
};

export const enablePublishFormButtons = () => {
    const copyShareLinkBtn = document.getElementById(FORM_SUBMIT_BUTTON_ID.cosellPublishForm.copyShareLink);
    copyShareLinkBtn.disabled = false;
    copyShareLinkBtn.classList.remove(FORM_SUBMIT_BUTTON_LOADING_CLASS);

    const copyEmbedCodeBtn = document.getElementById(FORM_SUBMIT_BUTTON_ID.cosellPublishForm.copyEmbedCode);
    copyEmbedCodeBtn.disabled = false;
    copyEmbedCodeBtn.classList.remove(FORM_SUBMIT_BUTTON_LOADING_CLASS);

    document.getElementById(SOCIAL_MEDIA_SHARE_BUTTON_ID.facebook).disabled = false;
    document.getElementById(SOCIAL_MEDIA_SHARE_BUTTON_ID.twitter).disabled = false;
    document.getElementById(SOCIAL_MEDIA_SHARE_BUTTON_ID.pinterest).disabled = false;
    document.getElementById(SOCIAL_MEDIA_SHARE_BUTTON_ID.whatsapp).disabled = false;
};

export const generatePublishEmbedCode = (productId, publishSlug) => {
    const publishLink = `${window[APP_DATA].cosell.origin}${publishSlug}&utm_medium=embed`;
    const env = window[APP_DATA].env;
    let shoptypeWidgetUrl = "";

    if (env === ENV_DEV) {
        shoptypeWidgetUrl = DEV_WIDGET_URL;
    } else if (env === ENV_BETA) {
        shoptypeWidgetUrl = BETA_WIDGET_URL;
    } else {
        shoptypeWidgetUrl = PROD_WIDGET_URL;
    }

    return `<div id="shoptype-widget-${productId}"></div>
    <script>
      var loadScriptAsync = function (uri) {
        return new Promise((resolve, reject) => {
          var tag = document.createElement("script");
          tag.src = uri;
          tag.async = true;
          tag.onload = () => {
            resolve();
          };
          var firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        });
      };
      var scriptLoaded = loadScriptAsync("${shoptypeWidgetUrl}");
    </script>
    <script>
      scriptLoaded.then(function () {
        renderWidget("shoptype-widget-${productId}", "${productId}", "${publishLink}", "landscape");
      });
    </script>
    `;
};

export const generatePublishLinks = async (token = null) => {
    const publishSlug = await getPublishSlug(token || window[APP_DATA].cosell.token, window[APP_DATA].cosell.productId);

    if (publishSlug && publishSlug.slug) {
        // update shareLink for later usage
        window[APP_DATA].shareLink = `${window[APP_DATA].cosell.origin}${publishSlug.slug}`;

        // share link
        const shareLink = `${window[APP_DATA].cosell.origin}${publishSlug.slug}&utm_medium=copy`;
        const shareLinkInput = document.getElementById(FORM_CONTROL.cosellPublishForm.shareLink.id);

        shareLinkInput.value = shareLink;

        // embed code
        const embedCode = generatePublishEmbedCode(window[APP_DATA].cosell.productId, publishSlug.slug);
        const embedCodeInput = document.getElementById(FORM_CONTROL.cosellPublishForm.embedCode.id);

        embedCodeInput.value = embedCode;

        enablePublishFormButtons();
    }
};

export const copyShareLink = () => {
    const shareLinkInput = document.getElementById(FORM_CONTROL.cosellPublishForm.shareLink.id);
    shareLinkInput.select();
    document.execCommand("copy");
};

export const copyEmbedCode = () => {
    const embedCodeInput = document.getElementById(FORM_CONTROL.cosellPublishForm.embedCode.id);
    embedCodeInput.select();
    document.execCommand("copy");
};

// first argument receives an array of button ids
export const removeButtonLoader = (ids) => {
    try {
        ids.forEach(id => {
            document.getElementById(id).classList.remove(FORM_SUBMIT_BUTTON_LOADING_CLASS);
        });
    } catch (err) {
        console.error(err);
    }
};

export const addQueryParamsToUrl = (link, queryParamsObject) => {
    let url = new URL(link);
    Object.keys(queryParamsObject).forEach(queryKey =>
        url.searchParams.append(queryKey, queryParamsObject[queryKey])
    );

    return url.href;
};

export const getProductPublishRequestBody = (medium) => {
    try {
        return {
            productId: window[APP_DATA].cosell.productId,
            vendorId: window[APP_DATA].cosell.productVendorId,
            referrerLink: window.location.href,
            link: addQueryParamsToUrl(window[APP_DATA].shareLink, { utm_medium: medium }),
            medium: medium,
            timestamp: new Date().getTime()
        }
    } catch (err) {
        console.error(err);
    }
};